import type { ReactElement } from "react";

import { IconEdit } from "@/components/generated/icons";
import { t } from "@/i18n/translate";
import type { DataEntryStatusName, Role } from "@/types/generated/openapi";
import { isTypist } from "@/utils/role";

import { Icon } from "../Icon/Icon";
import cls from "./Badge.module.css";

export type BadgeType = DataEntryStatusName | "first_entry_finalised_for_typist";

export interface LabelProps {
  label: string;
  icon?: ReactElement;
}

function typeToLabel(badgeType: BadgeType): LabelProps {
  switch (badgeType) {
    case "empty":
      return { label: t("data_entry.first_entry") };
    case "first_entry_in_progress":
    case "first_entry_correction":
      return { label: t("data_entry.first_entry"), icon: <Icon size="sm" icon={<IconEdit />} /> };
    case "first_entry_has_errors":
      return { label: t("data_entry.first_entry") };
    case "first_entry_finalised":
      return { label: t("data_entry.first_entry") };
    case "first_entry_finalised_for_typist":
      return { label: t("data_entry.second_entry") };
    case "second_entry_in_progress":
    case "second_entry_correction":
      return { label: t("data_entry.second_entry"), icon: <Icon size="sm" icon={<IconEdit />} /> };
    case "entries_different":
      return { label: t("data_entry.second_entry") };
    case "definitive":
      return { label: t("data_entry.definitive") };
  }
}

export interface BadgeProps {
  id?: string;
  type: BadgeType;
  userRole: Role;
  showIcon?: boolean;
}

export function Badge({ id, type, userRole, showIcon = false }: BadgeProps) {
  if (type === "first_entry_finalised" && isTypist(userRole)) {
    type = "first_entry_finalised_for_typist";
  }
  const { label, icon } = typeToLabel(type);
  return (
    <div id={id} className={`${cls[type]} ${cls.badge}`}>
      {label}
      {showIcon && icon}
    </div>
  );
}
